

import FmdGoodIcon from '@mui/icons-material/FmdGood';
import S from './SingleDam.module.css'
import {  Edit, Key, Sensors, Settings, TimelapseOutlined } from '@mui/icons-material'
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import W from './ListDam.module.css'

import { useParams } from 'react-router-dom'
import { useGlobalContext } from '../Components/Context'
import EditPacket from '../Components/editModalPacket'
import { loginSuccessSC } from '../redux/slices/singleCollectorSlice';
import G from '../images/package.svg'
import ReportIcon from '@mui/icons-material/Report';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';

import apiService from '../api/ApiService';
import { Switch } from '@mui/material';
const moment=require('moment-jalaali');

const SinglePacket=()=>{
    const {openModalls,isOpenModal}=useGlobalContext()
    const {currentCollector}=useSelector(state=>state.singleCollector)
    const {id}=useParams();
    const dispatch=useDispatch()
   
    const getLogs=async()=>{
            const res=await apiService.getPacket(id)
            dispatch(loginSuccessSC(res.data));
    }
    const toggle=async()=>{
        const res=await apiService.toggleActiveCollectors(id)
            dispatch(loginSuccessSC(res.data))
    }
    useEffect(()=>{
            getLogs();
    },[])
 
    return <>
    <div className={S.SingleDamCon}>
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
    <div className={S.SingleDamTitleCon}>
    <img style={{width:'72px',height:'72px'}} className={S.SingleDamimgTit} src={G}/>
        <h2>مشخصات کالکتور</h2>
        </div>
        <div onClick={openModalls} className={S.EditBtnTableDam}>
                <Edit sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
    </div>

        <hr/>
        <div className={W.AnimContentLI}>
        <table >
            <thead>
            <tr><th className={S.LogoFormT}><div><span>
                    <ReportIcon/></span></div></th>
                    
                
                    <th className={S.LogoFormT}><div><span><Sensors/></span></div></th>
                    <th className={S.LogoFormT}><div><span>
                    <ModelTrainingIcon/></span></div></th>
                    <th className={S.LogoFormT}><div><span>
                    <FmdGoodIcon/></span></div></th>
                    
                    <th className={S.LogoFormT}><div><span>
                    <TimelapseOutlined/></span></div></th>
                </tr>
            </thead>
            <tbody style={{margin:'0px auto'}}>
                
                <tr>
                <td className={S.TableFormTit}>فعال / غیر فعال</td>
                    
                    
                    <td className={S.TableFormTit}>کد دستگاه </td>
                    <td className={S.TableFormTit}>ورژن </td>
                    <td className={S.TableFormTit}>محل نصب </td>
                    
                    <td className={S.TableFormTit}>زمان ایجاد </td>
                    
                </tr>
                <tr>
                <td >
                <Switch color="success" checked={currentCollector?.isActive} onChange={()=>toggle()} />

                    </td>
                    <td>{currentCollector?.deviceCode}</td>
                    <td>{currentCollector?.version?currentCollector?.version:'---'}</td>
                    <td>{currentCollector?.installedLocation}</td>
                    
                    <td>{moment(currentCollector?.createAt).format('jYYYY-jMM-jDD HH:mm')}</td>

                </tr>
               
            </tbody>
        </table>
        </div>
        <div className='specsss' style={{display:'flex',gap:'18px',textAlign:'center',alignItems:'center',borderRight:'3px solid green' ,marginTop:'16px'}}>
          <div className='d-flex gap-1 align-items-center'>
          <div className='LogoFormT'>
          <div ><span>
                <Settings/>
                </span>
                    </div>
          </div>
                    <div className={S.TableFormTit}>   مشخصات </div>

          </div>
          <div>{currentCollector?.specs}</div>
        </div>
        
            


    </div>
    {isOpenModal&&<EditPacket penr={currentCollector}/>}
    </>
}

export default SinglePacket